import { Filter } from '../filter';
import { ErrorType, FieldValues } from '../types';

export class MultipleOfFilter implements Filter<number> {
    constructor(private multipleOfValue: number) {}

    async validate(fieldValue: number, otherFields: FieldValues): Promise<Array<ErrorType>> {
        // As Typescript is not capable of arithmetic remainder calculations
        // (ex: 1.8 % 0.2 = 0.199999), we need to rely on division
        if (!Number.isInteger(fieldValue / this.multipleOfValue)) {
            return [{ code: 'multipleOf', multiple: this.multipleOfValue }];
        }
        return [];
    }
}
